module.exports = __webpack_public_path__ + "img/chromeicon.13dd112a.png";